
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1989_27)","fill":"#282828"}},[_c('path',{attrs:{"d":"M18.997 11.99a1 1 0 00-1 1v8.006c0 .551-.448 1-1 1H3c-.553 0-1-.449-1-1V6.986c0-.55.447-1 1-1h7.998a1 1 0 000-2.002H3c-1.654 0-3 1.347-3 3.002v14.01a3.004 3.004 0 003 3.002h13.997c1.654 0 3-1.347 3-3.002v-8.005a1 1 0 00-1-1.001zM22.837 4.434l.62-.631c.76-.76.706-2.045-.054-2.806l-.399-.399c-.76-.76-2.043-.814-2.803-.054l-.63.62 3.266 3.27z"}}),_c('path',{attrs:{"d":"M8.994 11.772l-.027.027-1.956 5.034c-.049.124.075.248.204.205l5.02-1.97L22.346 4.947l-3.273-3.275L8.988 11.767l.006.005zm-.863 3.107l.992-2.535c.032.13.097.248.194.345a.795.795 0 00.658.216l.145-.016-.016.145a.822.822 0 00.221.664.783.783 0 00.658.216l.145-.016-.016.145a.794.794 0 00.216.658.803.803 0 00.377.205l-2.55.998-1.024-1.024zM19.41 4.414l.145.145-7.671 7.678-.145-.146 7.67-7.677z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1989_27"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    